'use client'
import React from 'react'
import { t } from 'i18next'
import Text from 'app/app/(client)/components/atoms/Text/Text'
import NoSearchResults from 'app/app/(client)/components/molecules/NoSearchResults/NoSearchResults'
import { Customer } from 'app/app/(client)/components/templates/Customer/Customer'
import Shimmer from 'app/app/(client)/components/templates/Customer/Shimmer'
import { CustomerModel, OpportunitiesProps } from 'app/types/ui/opportunity'

const MyOpportunities: React.FC<OpportunitiesProps> = ({ customers, dataStatus }) => {
  if (dataStatus === 'loading' || dataStatus === 'idle') {
    return (
      <div className="mt-6">
        <Shimmer />
      </div>
    )
  }

  if (dataStatus === 'failed') {
    return null
  }

  if (!customers) {
    return (
      <Text
        id="no-accounts-text"
        as="div"
        className="flex justify-center items-center min-h-100 text-center text-22px font-normal"
      >
        {t('customers.noAccounts')}
      </Text>
    )
  }

  if (customers.length === 0) {
    return <NoSearchResults />
  }

  return (
    <div className="flex flex-col gap-3 md:gap-6 items-center mt-6">
      {customers.map((customerValue: CustomerModel, index: number) => (
        <Customer key={index} {...customerValue} />
      ))}
    </div>
  )
}

export default React.memo(MyOpportunities)
